<template>
  <v-row justify="center">
    <v-dialog :value="updateClient" @click:outside="eventdialog" scrollable max-width="500">
      <ValidationObserver ref="obs" v-slot="{ passes }">
        <v-card>
          <v-progress-linear v-if="loading" indeterminate color="primary" rounded height="6"></v-progress-linear>

          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                Editar cliente externo
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text :style="`max-height: ${DIALOG_MAX_HEIGHT}`">
              <v-form>
                <v-row dense>
                  <v-col cols="12">
                    <ValidationProvider name="nombre del cliente de PBXBerry" v-slot="{ errors }">
                      <v-select
                        v-model="data.client_id"
                        :items="Clients"
                        :error-messages="errors"
                        :loading="isLoadingClients"
                        item-text="name"
                        item-value="id"
                        prepend-inner-icon="mdi-database"
                        label="Nombre del cliente de PBXBerry"
                        filled
                        rounded
                      ></v-select>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="nombre del cliente externo" rules="required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Nombre del cliente externo"
                        name="nombre"
                        prepend-inner-icon="mdi-account"
                        type="text"
                        color="blue-grey"
                        v-model="data.name"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="IP Cliente Externo" rules="required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="IP Cliente Externo"
                        name="ip"
                        prepend-inner-icon="mdi-web"
                        color="blue-grey"
                        v-model="data.ip"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="IPQA Cliente Externo" rules="required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="IPQA Cliente Externo"
                        name="ip_qa"
                        prepend-inner-icon="mdi-web"
                        color="blue-grey"
                        v-model="data.ip_qa"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="usuario" rules="required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Usuario"
                        name="usuario"
                        prepend-inner-icon="mdi-account"
                        color="blue-grey"
                        v-model="data.user_name"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="contraseña" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Contraseña"
                        name="password"
                        prepend-inner-icon="mdi-lock"
                        :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                        :type="showPassword ? 'text' : 'password'"
                        color="blue-grey"
                        v-model="data.secret"
                        :error-messages="errors"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>
                    </ValidationProvider>

                    <v-slide-y-transition>
                      <p v-if="secret" class="grey--text caption pb-3">
                        <v-icon small left color="blue-grey">mdi-information</v-icon>Recuerde anotar la contraseña para
                        entregársela al usuario.
                      </p>
                    </v-slide-y-transition>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </vuescroll>

          <v-divider></v-divider>

          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="eventdialog">Cancelar</v-btn>
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                :loading="loading"
                :disabled="loading"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="passes(updateForm)"
                >Actualizar</v-btn
              >
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </v-row>
</template>

<script>
import vuescroll from "vuescroll";
import { DIALOG_MAX_HEIGHT } from "@/utils";

export default {
  components: {
    vuescroll,
  },
  props: ["updateClient", "data"],
  data() {
    return {
      DIALOG_MAX_HEIGHT,
      loading: false,
      showPassword: false,
      errorData: "",
      activeAlert: "",
      colorAlert: "",
    };
  },
  methods: {
    eventdialog() {
      this.$emit("dialog:change", "cerrar");
    },
    async updateForm() {
      try {
        const data = {
          value: {
            client_id: this.data.client_id,
            name: this.data.name,
            ip: this.data.ip,
            ip_qa: this.data.ip_qa,
            user_name: this.data.user_name,
            secret: this.data.secret,
          },
          id: this.data.id,
        };
        await this.$store.dispatch("clients/EDIT_EXTERNAL_CLIENTS", data);
        this.$snotify.success("El cliente externo se ha actualizado con éxito.", "¡Hecho!");
        // this.errorData = response.data;
        // this.activeAlert = true;
        // this.colorAlert = "blue";
        this.$emit("dialog:change", "Actualizado");
      } catch (error) {
        this.$snotify.error(error.response.data, "¡Error!");
        // this.errorData = error.response.data;
        // this.activeAlert = true;
        // this.colorAlert = "red";
      }
    },
  },
};
</script>

<style></style>
